import { render, staticRenderFns } from "./UserRemoveWarning.vue?vue&type=template&id=4c3ab79e&scoped=true"
import script from "./UserRemoveWarning.vue?vue&type=script&lang=js"
export * from "./UserRemoveWarning.vue?vue&type=script&lang=js"
import style0 from "./UserRemoveWarning.vue?vue&type=style&index=0&id=4c3ab79e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c3ab79e",
  null
  
)

export default component.exports